if (!customElements.get('jky-v5-sticky-cart')) {
      customElements.define('jky-v5-sticky-cart', class JkyStickyCart extends HTMLElement {
        constructor() {
          super();

          // url链接，携带的【捆绑销售】标签
          this.bundledTag = getUrlQueryParams('bundled_action_tag') || ''
          // url链接，携带的【产品推荐】标签
          this.recommendedTag = getUrlQueryParams('action_tag') || ''

          this.is_diy = this.hasAttribute('is-diy');
          this.sticky_cart_bg_style = this.getAttribute('sticky_cart_bg_style');
          this.scrollRestoreSyncFrame = 0
          this.scrollRestoreSyncFrameNext = 0
          this.scrollRestoreSyncTimeout = 0
          this.observer = null
          this.handleStickyRefresh = this.handleStickyRefresh.bind(this)
          this.handleStickyScroll = this.handleStickyScroll.bind(this)
        }
        connectedCallback() {
          this.init()

          // DIY产品页面：吸底购物车常驻显示 非DIY页面：使用原来的滚动触发逻辑
          if (this.is_diy) {
            this.style.display = 'block';
            return;
          }
          this.refreshObserveTargets()
          window.addEventListener('scroll', this.handleStickyScroll, { passive: true })
          window.addEventListener('resize', this.handleStickyRefresh)
          window.addEventListener('load', this.handleStickyRefresh)
          window.addEventListener('pageshow', this.handleStickyRefresh)
          this.queueStickyVisibilitySync(true)
        }
        disconnectedCallback() {
          this.observer?.disconnect()
          window.removeEventListener('scroll', this.handleStickyScroll)
          window.removeEventListener('resize', this.handleStickyRefresh)
          window.removeEventListener('load', this.handleStickyRefresh)
          window.removeEventListener('pageshow', this.handleStickyRefresh)
          cancelAnimationFrame(this.scrollRestoreSyncFrame)
          cancelAnimationFrame(this.scrollRestoreSyncFrameNext)
          clearTimeout(this.scrollRestoreSyncTimeout)
        }
        handleStickyRefresh() {
          this.refreshObserveTargets()
          this.queueStickyVisibilitySync(true)
        }
        handleStickyScroll() {
          this.queueStickyVisibilitySync()
        }
        getDesktopTriggerSelectors() {
          return [
            '[data-sticky-cart-price-trigger]',
            '[data-sticky-cart-title-trigger]',
            'v5-product-form',
            'product-shortage'
          ]
        }
        getMobileTriggerSelectors() {
          return [
            '[data-sticky-cart-gallery-trigger]',
            '[data-sticky-cart-price-trigger]',
            '[data-sticky-cart-title-trigger]',
            'v5-product-form',
            'product-shortage'
          ]
        }
        getAllTriggerSelectors() {
          return [...new Set([
            ...this.getDesktopTriggerSelectors(),
            ...this.getMobileTriggerSelectors()
          ])]
        }
        getTriggerTarget(selectors = []) {
          for (const selector of selectors) {
            const target = document.querySelector(selector)
            if (target && document.body.contains(target)) {
              return target
            }
          }
          return null
        }
        getHeaderHeight() {
          if (this._headerHeight === undefined) {
            const raw = getComputedStyle(document.body).getPropertyValue('--jky-header-h').trim()
            const px = parseFloat(raw)
            this._headerHeight = Number.isFinite(px) ? px : 0
          }
          return this._headerHeight
        }
        getCurrentTriggerTarget() {
          if (window.innerWidth >= 1024) {
            return this.getTriggerTarget(this.getDesktopTriggerSelectors())
          }
          return this.getTriggerTarget(this.getMobileTriggerSelectors())
        }
        refreshObserveTargets() {
          this.observer?.disconnect()

          const observeTargets = this.getAllTriggerSelectors()
            .map((selector) => document.querySelector(selector))
            .filter((target, index, targets) => target && document.body.contains(target) && targets.indexOf(target) === index)

          if (!observeTargets.length) {
            this.observer = null
            return
          }

          this.observer = new IntersectionObserver(() => {
            this.queueStickyVisibilitySync()
          }, {
            root: null,
            threshold: [0, 1]
          })

          observeTargets.forEach((target) => this.observer.observe(target))
        }
        queueStickyVisibilitySync(includeDelayedSync = false) {
          cancelAnimationFrame(this.scrollRestoreSyncFrame)
          cancelAnimationFrame(this.scrollRestoreSyncFrameNext)
          clearTimeout(this.scrollRestoreSyncTimeout)

          this.scrollRestoreSyncFrame = requestAnimationFrame(() => {
            this.scrollRestoreSyncFrameNext = requestAnimationFrame(() => {
              this.updateStickyVisibility()
            })
          })

          if (includeDelayedSync) {
            // 刷新返回时，浏览器可能在更晚时机恢复滚动位置，这里再补一次延迟校准
            this.scrollRestoreSyncTimeout = window.setTimeout(() => {
              this.updateStickyVisibility()
            }, 160)
          }
        }
        ensureVisible() {
          this.style.display = 'block'
        }
        updateStickyVisibility() {
          if (this.is_diy) {
            this.ensureVisible()
            this.classList.remove('is-hidden')
            return
          }

          const target = this.getCurrentTriggerTarget()

          if (!target || !document.body.contains(target)) {
            this.ensureVisible()
            this.classList.add('is-hidden')
            return
          }

          const targetRect = target.getBoundingClientRect()
          const headerH = this.getHeaderHeight()
          const isMobileGalleryTrigger = window.innerWidth < 1024 && target.hasAttribute('data-sticky-cart-gallery-trigger')
          const shouldShow = isMobileGalleryTrigger
            ? targetRect.top <= headerH - window.innerHeight * 0.35
            : targetRect.bottom <= headerH

          this.ensureVisible()
          this.classList.toggle('is-hidden', !shouldShow)
        }
        init() {
          // 重置缓存，确保从当前 DOM 中重新解析变体数据
          this.variantData = null

          this.select_id = Number(this.getAttribute("init-variant-id"))
          this.hideAddToCartPrice = this.hasAttribute('hide-add-to-cart-price')
          this.addButton = this.querySelector('#sticky_addToCart')
          this.variantsButtons = this.querySelectorAll(".disclosure-list-menu li")
          this.skuDetails = this.querySelector("details-disclosure details")
          this.variantFields = document.querySelector("variant-fields")
          this.quantityInputEl = document.querySelector('quantity-input[data-v5-app-pdp-quantity] input')

          this.enable_shortage_reminds = this.getAttribute("enable_shortage_reminds") === "true"
          this.addButton_dom = this.querySelector('.sticky_cart_addToCart')
          this.shortage_dom = this.querySelector('.shortage-btn')
          this.buyNowButton = this.querySelector('#sticky_buyNow')
  
          this.updateMasterId();
  
          for(let i = 0; i < this.variantsButtons.length; i++) {
            const target = this.variantsButtons[i];
            target.addEventListener("click", this.onVariantChange.bind(this))
          }
  
          this.addButton.addEventListener("click", (e) => {
            const quantity = this.getMainProductQuantity()
            if (this.currentVariant?.open_tax_free_popup_before_buy) {
              try {
                document.querySelector('v5-product-form')?.showTaxFreePopup(() => this.addToCart(e, this.select_id, quantity))
              } catch (err) {
                this.addToCart(e, this.select_id, quantity)
              }
            } else {
              this.addToCart(e, this.select_id, quantity)
            }
          })

          if (this.shortage_dom) {
            this.shortage_dom.addEventListener("click", () => this.handleShortageClick())
          }

          if (this.buyNowButton) {
            this.buyNowButton.addEventListener("click", (e) => {
              e?.preventDefault()
              if (this.currentVariant?.open_tax_free_popup_before_buy) {
                try {
                  document.querySelector('v5-product-form')?.showTaxFreePopup(() => this.handleBuyNow())
                } catch (err) {
                  this.handleBuyNow()
                }
              } else {
                this.handleBuyNow();
              }
            })
          }

          // 有多个变体，监听 details open。单个变体时，没有渲染details-disclosure组件
          if (this.querySelector('details-disclosure')) {
            this.querySelector('details-disclosure').handleOpen = () => {
              this.querySelector('.v5-jky-sticky-cart').style.zIndex = this.querySelector('.v5-jky-sticky-cart').getAttribute('data-unfold-zindex')
              const ulDOM = this.skuDetails?.querySelector('ul')
              // 查找 .active 元素并滚动到其位置
              const activeElement = ulDOM.querySelector("li.active");
              if (activeElement) {
                activeElement.scrollIntoView({ behavior: "smooth", block: "center" });
              }

              gaPushDataLayer('5.0_products_details_page_user_clicks', {
                "product_spu_name": this.getAttribute('product-title'),
                "module": "Bottom Cart",
                "options": this.currentVariant?.title,
                "type": "open"
              })
            }
            this.querySelector('details-disclosure').handleClose = () => {
              this.querySelector('.v5-jky-sticky-cart').style.zIndex = this.querySelector('.v5-jky-sticky-cart').getAttribute('data-zindex')
            }
          }
        } 
        // 到货提醒
        handleShortageClick() {
          if(document.querySelector("product-shortage")) {
            document.querySelector("product-shortage").bindEvents()
          }
        }
        // 变体切换
        onVariantChange(e) {
          const target = e.currentTarget;
          if(target.classList.contains("active")) return

          this.open_tax_free_popup_before_buy = target.dataset.taxFreePopup == "true"
          const isSoldOut = target.hasAttribute("disabled");
          if (this.addButton.classList.contains("loading")) return;
  
          this.updateOptions(target);
          this.updateMasterId();
          this.updateProductInfo();
  
          this.skuDetails && this.skuDetails.removeAttribute("open");

          // dispatch variant change
          if(document.querySelector("variant-fields") && this.currentVariant) {
            document.querySelector("variant-fields").onVariantChange(this.currentVariant.id)
          }
          
          this.updateCartBtn(isSoldOut);

          // change url variant
          const url = new URL(window.location);
          url.searchParams.set("variant", this.select_id);

          // 携带 捆绑销售 标签
          if (this.bundledTag) {
            url.searchParams.set("bundled_action_tag", this.bundledTag);
          } 
          // 携带 产品推荐 标签
          else if (this.recommendedTag) {
            url.searchParams.set("action_tag", this.recommendedTag);
          }
          window.history.replaceState({}, "", url);
        }
        // 更新按钮状态
        updateCartBtn(isSoldOut) {
          if(isSoldOut) {
            if(this.enable_shortage_reminds) {
              this.addButton_dom.classList.add("!hidden")
              this.shortage_dom.classList.remove("!hidden")
            } else {
              this.addButton.setAttribute("disabled", true);
              this.addButton.querySelector('span:last-of-type').textContent = window.pageInfo.strings.product.soldOut;
            }
          } else {
            if(this.enable_shortage_reminds) {
              this.shortage_dom.classList.add("!hidden");
            }
            this.addButton_dom.classList.remove("!hidden");
            this.addButton.removeAttribute("disabled");
          }
        }
        // 更新选项
        updateOptions(target) {
          this.select_id = Number(target.getAttribute("data-id"))
          Array.from(this.querySelectorAll('.disclosure-list-menu li'), (variant) => {
            variant.classList.remove("active")
            if(Number(variant.getAttribute("data-id")) === this.select_id) {
              variant.classList.add("active")
            }
          })
        }
        // 获取变体数据
        updateMasterId() {
          this.currentVariant = this.getVariantData().find((variant, index) => {
            return variant.id === this.select_id
          });
        }
        // 更新商品信息
        updateProductInfo() {
          const variant_title = this.querySelector(".variant-title")
          if (!this.currentVariant) return;
          // 标题 
          variant_title.innerHTML = `
            ${this.currentVariant.variant_tag
              ? `<span class="hidden lg:flex items-center justify-center ${this.sticky_cart_bg_style === 'light' ? 'bg-[#242F20] text-white' : 'bg-white text-[#242F20]'} font-semibold lg:text-base leading-[1.75rem] px-2 lg:px-3">${this.currentVariant.variant_tag}</span>`
              : ''
            }
            <span class="flex-1 ${this.sticky_cart_bg_style === 'light' ? 'text-[#242F20]' : 'text-white'} font-semibold text-overflow-1">${this.currentVariant.title}</span>
          `

          gaPushDataLayer('5.0_products_details_page_user_clicks', {
            "product_spu_name": this.getAttribute('product-title'), 
            "module": "Bottom Cart",
            "options": this.currentVariant?.title,
            "type": "choose"
          })
        }
        getVariantData() {
          this.variantData = this.variantData || JSON.parse(document.querySelector(`[id="selected-variant"][type="application/json"]`)?.textContent || '[]');
          return this.variantData;
        }
        getMainProductQuantity() {
          const quantity = Number(this.quantityInputEl?.value || 1)
          return Number.isFinite(quantity) && quantity > 0 ? quantity : 1
        }
        // 添加商品属性
        getCartFormPrams() {
          const paramObj = {
            properties: {},
            params: {}
          };

          // 1. 获取表单元素
          const form = document.querySelector('.product-single__form');
          if (!form) return paramObj;

          // 2. 使用 FormData 获取所有数据
          const formData = new FormData(form);

          // 3. 遍历数据
          formData.forEach((value, name) => {
            // 判断归属于 properties 还是 params
            const targetKey = name.includes('properties') ? 'properties' : 'params';
            const targetGroup = paramObj[targetKey];

            if (targetGroup.hasOwnProperty(name)) {
              // 如果已存在该属性，转换为数组并 push
              if (!Array.isArray(targetGroup[name])) {
                targetGroup[name] = [targetGroup[name]];
              }
              targetGroup[name].push(value);
            } else {
              // 第一次出现，直接赋值
              targetGroup[name] = value;
            }
          });

          return paramObj;
        }
        getBundleActionProperties() {
          if (this.bundledTag) {
            return { Action: this.bundledTag.replace('_', ' ') }
          }

          if (this.recommendedTag) {
            return { Action: this.recommendedTag }
          }

          return {}
        }
        getSelectedBundlesFromDom() {
          const bundledSaleRoots = [
            ...document.querySelectorAll('jky-v5-app-bundled-sale-plus, jky-v5-app-bundled-sale')
          ]
          if (!bundledSaleRoots.length) return []

          const selectedBundles = []

          bundledSaleRoots.forEach((bundledSaleRoot) => {
            const checkedInputs = [
              ...bundledSaleRoot.querySelectorAll('input[type="checkbox"][data-bundle-sku-id]:checked, input[type="checkbox"][skuId]:checked')
            ]

            checkedInputs.forEach((input) => {
              const label = input.closest('label')
              const quantityInput = label?.querySelector('[data-quantity-input], input[type="number"][skuId], input[type="number"][data-sku-id]')

              selectedBundles.push({
                skuId: Number(
                  input.dataset.bundleSkuId
                  || input.getAttribute('skuId')
                  || quantityInput?.dataset?.skuId
                  || quantityInput?.getAttribute('skuId')
                  || quantityInput?.getAttribute('data-sku-id')
                  || 0
                ),
                quantity: Number(quantityInput?.value || 1),
              })
            })
          })

          return selectedBundles.filter((bundle) => Number.isFinite(bundle.skuId) && bundle.skuId > 0 && Number(bundle.quantity) > 0)
        }
        buildBundledItems(variantId, quantity = 1) {
          const actionProperties = this.getBundleActionProperties()
          const items = [{
            id: Number(variantId),
            quantity: Number(quantity || 1),
            properties: {
              ...this.getCartFormPrams().properties,
              ...this.getWarrantyProperties(),
              ...actionProperties,
            }
          }]

          if (this.sellingPlan?.value) {
            items[0].selling_plan = this.sellingPlan.value
          }

          this.getSelectedBundlesFromDom().forEach((bundle) => {
            items.push({
              id: Number(bundle.skuId),
              quantity: Number(bundle.quantity || 1),
              properties: actionProperties
            })
          })

          return items
        }
        // 解析产品延保信息
        parseProductWarrantyInfo(info) {
          const normalized = String(info || '').trim().replace(/：/g, ':');
          const separatorIndex = normalized.indexOf(':');
          if (separatorIndex < 0) return { key: '', value: '', properties: {} };
          const key = normalized.slice(0, separatorIndex).trim();
          const value = normalized.slice(separatorIndex + 1).trim();
          if (!key || !value) return { key: '', value: '', properties: {} };
          return { key, value, properties: { [key]: value } };
        }
        // 获取当前变体的延保属性
        getWarrantyProperties() {
          return this.parseProductWarrantyInfo(this.currentVariant?.sku_warranty_info).properties;
        }
        addToCart(e, id, quantity = 1) {
          this.sellingPlan = document.querySelector('input[name="selling_plan"]') || '';
          this.addButton.classList.add("loading");

          if (typeof id !== 'number' || isNaN(id)) {
            throw new TypeError('Theme Cart: Variant ID must be a number');
          }
          const cart = document.querySelector('cart-drawer,jky-cart');

          let items = []

          if(this.is_diy) {
            items = this.handleDiyAddToCart();
          } else {
            items = this.buildBundledItems(id, quantity)
          }

          fetch('/cart/add.js', {
            credentials: 'same-origin',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Content-Type': 'application/json;',
            },
            method: 'POST',
            body: JSON.stringify({ items: items, ...(fixRefreshCartDom ? fixRefreshCartDom() : {}) }),
          }).then((r) => {
            let { status, statusText } = r;

            if(status === 422) {
              r.json().then(errorData => {
                const message = errorData.message || statusText
                pushErrorMessage(message)
              })
            } else {
              // 物自体：加购成功后逐件上报 nm_add_cart（拿不到 product_id / quantity 的那件就不报）；整条受 window.__nmEnabled() 总开关管（判据定义在 global-core.js 顶部）
              if (window.__nmEnabled?.()) r.clone().json().then((d) => { (d?.items ?? []).forEach((l) => { if (l?.product_id && Number.isInteger(l.quantity) && l.quantity >= 1) window.__nm?.getCartAttributes?.({ path: 'ajax', item_id: String(l.product_id), ...(l.variant_id ? { variant_id: String(l.variant_id) } : {}), qty: l.quantity }); }); }).catch(() => {});

              if(cart && cart.renderContents) {
                cart.renderContents(r);
              } else {
                window.location.href = '/cart'
              }

              gaPushDataLayer('5.0_products_details_page_user_clicks', {
                "product_spu_name": this.getAttribute('product-title'),
                "module": "Bottom Cart",
                "options": this.currentVariant?.title,
                "button_name": this.addButton?.textContent?.trim()
              })
            }
          }).catch(err => {
            console.error(err)
          }).finally(() => {
            this.addButton.classList.remove("loading")
            this.addButton.removeAttribute('aria-disabled')
            if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty')
          })
        }

        handleDiyAddToCart() {
          this.diy_tag = null;
          if(this.is_diy) {
            if(document.querySelector("v5-diy-main")?.active?.getAttribute?.('data-tab') === 'diy-custom-info') { // 推荐
              this.diy_tag = 'recommend';
            } else { // 自定义
              this.diy_tag = 'diy';
            }
          }

          const picker = document.querySelector('variant-fields');
          if(!picker) return;
          const summaryData = picker.selectedSummary;

          this.processSkuData = (inputData) => {
            const result = [];

            if (Array.isArray(inputData.bundles) && inputData.bundles.length > 0) {
              inputData.bundles.forEach(bundle => {
                // skuId对应输出的id，quantity不存在则默认1
                const id = bundle.skuId;
                const quantity = bundle.quantity ?? 1;
                if (id) {
                  //确保id存在才添加
                  const _item = { id, quantity }
                  this.sellingPlan && (_item.selling_plan = this.sellingPlan?.value || '')
                  result.push(_item);
                }
              });
            }
          
            if (inputData.variant && inputData.variant.id) {
              const _item = {
                id: inputData.variant.id,
                // variant的quantity固定默认1
                quantity: 1
              }
              this.sellingPlan && (_item.selling_plan = this.sellingPlan?.value || '')
              result.push(_item);
            }

            if (this.diy_tag) {
              result.forEach(item => {
                item.properties = { _DIY_tab: this.diy_tag.replace('_', ' ') };
              });
            }
          
            return result;
          }
          return this.processSkuData(summaryData);
        }

        async handleBuyNow() {
          if (this.buyNowButton.classList.contains("loading")) return;
          this.buyNowButton.classList.add("loading");

          let items = [];
          if(this.is_diy) {
            items = this.handleDiyAddToCart();
          } else {
            this.sellingPlan = document.querySelector('input[name="selling_plan"]') || '';
            items = this.buildBundledItems(this.select_id, this.getMainProductQuantity())
          }

          const checkoutUrl = await createCartAndCheckout(items) 
          window.location.href = checkoutUrl
          this.buyNowButton.classList.remove('loading')
          
          gaPushDataLayer('5.0_products_details_page_user_clicks', {
            "product_spu_name": this.getAttribute('product-title'),
            "module": "Bottom Cart",
            "options": this.currentVariant?.title,
            "button_name": this.buyNowButton?.textContent?.trim()
          })
        }
      })
    }
